import ReactSelect from 'react-select';
import PropTypes from 'prop-types';

export const BuildingCategory = ({
  values,
  handleChangeCaracObj,
  errors,
  touched
}) => {
  const options = [
    { value: '', label: 'Seleccione' },
    { value: 1, label: 'Excelente' },
    { value: 2, label: 'Muy Bueno' },
    { value: 3, label: 'Bueno' },
    { value: 4, label: 'Standard' }
  ];
  return (
    <div>
      <label>Categoría del Edificio</label>
      <ReactSelect
        name="buildingCategory"
        placeholder="-- Seleccione la Categoría --"
        options={options}
        value={options.find(v => v.value === values)}
        onChange={e => {
          handleChangeCaracObj('buildingCategory', e?.value && Number(e.value));
        }}
      />
      {errors?.type && touched?.type && (
        <label className="w-100 text-danger">{errors.type}</label>
      )}
    </div>
  );
};

BuildingCategory.propTypes = {
  values: PropTypes.object,
  handleChangeCaracObj: PropTypes.func,
  errors: PropTypes.object,
  touched: PropTypes.object
};
